import ApplicationSerializer from "./application";
import { EmbeddedRecordsMixin } from "@ember-data/serializer/rest";

export default class PrivateNetworkSegmentSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin) {
  usesProxy = true;

  attrs = {
    dataCenter: "datacenter",
    privateNetwork: "privatenetworkid",
    networkAdapters: {
      key: "networkadapters",
      embedded: "always",
    },
  };

  serialize(snapshot) {
    let json = super.serialize(...arguments);

    if (!("routable" in snapshot.changedAttributes())) {
      delete json.routable;
    }

    return json;
  }
}
